/* generated by Svelte v3.9.1 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	component_subscribe,
	destroy_component,
	destroy_each,
	detach,
	element,
	group_outros,
	init,
	insert,
	mount_component,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "svelte/internal";
import { onMount } from "svelte"
import Cell from "./components/Cell.svelte"
import PatternSelector from "./components/PatternSelector.svelte"
import SpeedControl from "./components/SpeedControl.svelte"
import RefreshButton from "./components/RefreshButton.svelte"
import TrashButton from "./components/TrashButton.svelte"
import FigureButtons from "./components/FigureButtons.svelte"
import PauseButton from "./components/PauseButton.svelte"
import {
    gamePattern,
    grid,
    gridSize,
    lifeSpeed,
    cellSize,
    gameStatus
  } from "src/store.js"
import { PATTERNS } from "src/constants"
import {
    countNearestCells,
    drawFiguresInGrid,
    generateGrid,
    fillGridWithRnd
  } from "src/gridHelper"
import { getGridStyle } from "src/utils"

function add_css() {
	var style = element("style");
	style.id = 'svelte-11u1euq-style';
	style.textContent = ".root.svelte-11u1euq{width:100%;display:flex}.settings.svelte-11u1euq{flex:1}.settings.svelte-11u1euq{align-items:center;justify-content:center;display:flex;flex-direction:column}.settings-content.svelte-11u1euq{min-width:250px}.grid.svelte-11u1euq{display:grid;justify-self:center}@media only screen and (max-width: 600px){.root.svelte-11u1euq{flex-direction:column;align-items:center}.grid.svelte-11u1euq{order:1}.settings.svelte-11u1euq{margin-top:50px;order:2}}";
	append(document.head, style);
}

function get_each_context(ctx, list, i) {
	const child_ctx = Object.create(ctx);
	child_ctx.cell = list[i];
	child_ctx.i = i;
	return child_ctx;
}

// (152:4) {#each $grid as cell, i}
function create_each_block(ctx) {
	var current;

	var cell = new Cell({
		props: {
		cellState: ctx.cell,
		index: ctx.i
	}
	});

	return {
		c() {
			cell.$$.fragment.c();
		},

		m(target, anchor) {
			mount_component(cell, target, anchor);
			current = true;
		},

		p(changed, ctx) {
			var cell_changes = {};
			if (changed.$grid) cell_changes.cellState = ctx.cell;
			cell.$set(cell_changes);
		},

		i(local) {
			if (current) return;
			transition_in(cell.$$.fragment, local);

			current = true;
		},

		o(local) {
			transition_out(cell.$$.fragment, local);
			current = false;
		},

		d(detaching) {
			destroy_component(cell, detaching);
		}
	};
}

function create_fragment(ctx) {
	var div5, div2, div1, div0, t0, t1, t2, br0, t3, t4, br1, t5, t6, br2, t7, t8, div3, div3_style_value, t9, div4, current;

	var pausebutton = new PauseButton({});

	var refreshbutton = new RefreshButton({});
	refreshbutton.$on("reset", ctx.resetGame);

	var trashbutton = new TrashButton({});

	var patternselector = new PatternSelector({});

	var figurebuttons = new FigureButtons({});

	var speedcontrol = new SpeedControl({});

	var each_value = ctx.$grid;

	var each_blocks = [];

	for (var i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			div5 = element("div");
			div2 = element("div");
			div1 = element("div");
			div0 = element("div");
			pausebutton.$$.fragment.c();
			t0 = space();
			refreshbutton.$$.fragment.c();
			t1 = space();
			trashbutton.$$.fragment.c();
			t2 = space();
			br0 = element("br");
			t3 = space();
			patternselector.$$.fragment.c();
			t4 = space();
			br1 = element("br");
			t5 = space();
			figurebuttons.$$.fragment.c();
			t6 = space();
			br2 = element("br");
			t7 = space();
			speedcontrol.$$.fragment.c();
			t8 = space();
			div3 = element("div");

			for (var i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t9 = space();
			div4 = element("div");
			attr(div0, "class", "form-item");
			attr(div1, "class", "settings-content svelte-11u1euq");
			attr(div2, "class", "settings svelte-11u1euq");
			attr(div3, "style", div3_style_value = getGridStyle(ctx.$gridSize, ctx.$cellSize));
			attr(div3, "class", "grid svelte-11u1euq");
			attr(div4, "class", "settings svelte-11u1euq");
			attr(div5, "class", "root svelte-11u1euq");
		},

		m(target, anchor) {
			insert(target, div5, anchor);
			append(div5, div2);
			append(div2, div1);
			append(div1, div0);
			mount_component(pausebutton, div0, null);
			append(div0, t0);
			mount_component(refreshbutton, div0, null);
			append(div0, t1);
			mount_component(trashbutton, div0, null);
			append(div1, t2);
			append(div1, br0);
			append(div1, t3);
			mount_component(patternselector, div1, null);
			append(div1, t4);
			append(div1, br1);
			append(div1, t5);
			mount_component(figurebuttons, div1, null);
			append(div1, t6);
			append(div1, br2);
			append(div1, t7);
			mount_component(speedcontrol, div1, null);
			append(div5, t8);
			append(div5, div3);

			for (var i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div3, null);
			}

			append(div5, t9);
			append(div5, div4);
			current = true;
		},

		p(changed, ctx) {
			if (changed.$grid) {
				each_value = ctx.$grid;

				for (var i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(changed, child_ctx);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(div3, null);
					}
				}

				group_outros();
				for (i = each_value.length; i < each_blocks.length; i += 1) out(i);
				check_outros();
			}

			if ((!current || changed.$gridSize || changed.$cellSize) && div3_style_value !== (div3_style_value = getGridStyle(ctx.$gridSize, ctx.$cellSize))) {
				attr(div3, "style", div3_style_value);
			}
		},

		i(local) {
			if (current) return;
			transition_in(pausebutton.$$.fragment, local);

			transition_in(refreshbutton.$$.fragment, local);

			transition_in(trashbutton.$$.fragment, local);

			transition_in(patternselector.$$.fragment, local);

			transition_in(figurebuttons.$$.fragment, local);

			transition_in(speedcontrol.$$.fragment, local);

			for (var i = 0; i < each_value.length; i += 1) transition_in(each_blocks[i]);

			current = true;
		},

		o(local) {
			transition_out(pausebutton.$$.fragment, local);
			transition_out(refreshbutton.$$.fragment, local);
			transition_out(trashbutton.$$.fragment, local);
			transition_out(patternselector.$$.fragment, local);
			transition_out(figurebuttons.$$.fragment, local);
			transition_out(speedcontrol.$$.fragment, local);

			each_blocks = each_blocks.filter(Boolean);
			for (let i = 0; i < each_blocks.length; i += 1) transition_out(each_blocks[i]);

			current = false;
		},

		d(detaching) {
			if (detaching) {
				detach(div5);
			}

			destroy_component(pausebutton);

			destroy_component(refreshbutton);

			destroy_component(trashbutton);

			destroy_component(patternselector);

			destroy_component(figurebuttons);

			destroy_component(speedcontrol);

			destroy_each(each_blocks, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $gridSize, $grid, $gamePattern, $gameStatus, $lifeSpeed, $cellSize;

	component_subscribe($$self, gridSize, $$value => { $gridSize = $$value; $$invalidate('$gridSize', $gridSize); });
	component_subscribe($$self, grid, $$value => { $grid = $$value; $$invalidate('$grid', $grid); });
	component_subscribe($$self, gamePattern, $$value => { $gamePattern = $$value; $$invalidate('$gamePattern', $gamePattern); });
	component_subscribe($$self, gameStatus, $$value => { $gameStatus = $$value; $$invalidate('$gameStatus', $gameStatus); });
	component_subscribe($$self, lifeSpeed, $$value => { $lifeSpeed = $$value; $$invalidate('$lifeSpeed', $lifeSpeed); });
	component_subscribe($$self, cellSize, $$value => { $cellSize = $$value; $$invalidate('$cellSize', $cellSize); });

	

  let gameTimeout = null
  
  const initGame = () => {
    const newGrid = generateGrid($gridSize)
    fillGridWithRnd(newGrid, Math.round(($gridSize**2) / 7))
    grid.set(newGrid)
    loop()
  }

  const destroyGame = () => {
    clearTimeout(gameTimeout)
    grid.set([])
  }

  const resetGame = () => {
    destroyGame()
    initGame()
  }

  const loop = () => {
    gameTimeout = setTimeout(() => {
      const newGrid = [...$grid]

      $grid.forEach((cell, index) => {
        const neighbours = countNearestCells({
          index,
          grid: $grid,
          gridSize: $gridSize
        })

        newGrid[index] = PATTERNS[$gamePattern](cell, neighbours)
      })
    grid.set(newGrid)
    $gameStatus && loop()
    }, 1000 - $lifeSpeed)
  }

  // Start $gridSize watching
  const unsubscribeGridSize = gridSize.subscribe(nextVal => {
    destroyGame()
    initGame()
  })
  
  // Start $gameStatus watching
  const unsubscribeGameStatus = gameStatus.subscribe(nextVal => {
    if (!nextVal) {
      clearTimeout(gameTimeout)
    } else {
      loop()
    }
	})

  onMount(resetGame)

	return { resetGame, $gridSize, $grid, $cellSize };
}

class Component extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-11u1euq-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, []);
	}
}

export default Component;